<app-navbar-style-two></app-navbar-style-two>
<app-partner></app-partner>

<!-- Start Page Title Area -->
<!-- <div class="page-title-area" *ngFor="let Content of pageTitle;"
    style="background-image: url({{Content.bgImage}});">
    <h1>{{Content.title}}</h1>
    <ul>
        <li><a routerLink="/">Home</a></li>
        <li>{{Content.title}}</li>
    </ul>
</div> -->
<!-- End Page Title Area -->

<!-- Start Services Area -->
<section class="services-section">
    <div class="container">
        <!-- Section Header -->
        <div class="section-header" *ngFor="let Content of servicesContent;">
            <div class="section-badge">{{Content.subTitle}}</div>
            <h2 class="section-title">{{Content.title}}</h2>
            <p class="section-description">{{Content.paragraph}}</p>
        </div>
    </div>
</section>

<!-- Services Content Area -->
<section class="services-area pt-100 pb-70">
    <div class="container">
        <div class="services-content" *ngFor="let Content of servicesContent;">

            <!-- Loading State -->
            <div class="text-center mt-5" *ngIf="isLoading">
                <div class="spinner-border text-danger" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2">Loading services...</p>
            </div>

            <!-- Error State -->
            <div class="alert alert-danger mt-5 text-center" *ngIf="hasError && !isLoading">
                <i class="bx bx-error-circle me-2"></i>
                Failed to load services. Please try again later.
            </div>

            <!-- Empty State -->
            <div class="alert alert-info mt-5 text-center"
                *ngIf="!isLoading && !hasError && services.length === 0">
                No services available at the moment.
            </div>

            <!-- Services Grid -->
            <div class="row mt-5" *ngIf="!isLoading && !hasError && services.length > 0">
                <div class="col-lg-4 col-md-6 mb-4" *ngFor="let service of services;">
                    <div class="service-card">
                        <div class="service-icon">
                            <i class="bx" [ngClass]="service.icon"></i>
                        </div>
                        <div class="service-content">
                            <h3>{{service.title}}</h3>
                            <p>{{service.description}}</p>
                            <ul class="service-features" *ngIf="service.features.length > 0">
                                <li *ngFor="let feature of service.features">
                                    <i class="bx bx-check"></i> {{feature}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Area -->

<!-- <app-why-choose-us></app-why-choose-us>
<app-testimonials></app-testimonials> -->